import { render, staticRenderFns } from "./my-upload.vue?vue&type=template&id=3227491b&scoped=true"
import script from "./my-upload.vue?vue&type=script&lang=js"
export * from "./my-upload.vue?vue&type=script&lang=js"
import style0 from "./my-upload.vue?vue&type=style&index=0&id=3227491b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3227491b",
  null
  
)

export default component.exports